import { VenueEntity } from '../../apis/venue/venue-entity';

export class VenueModel {
    public fieldId: number = null;
    public venue: VenueEntity = null;
    private _mappedVenueId: string = null;

    constructor(fieldId: number, venue: VenueEntity, mappedVenueId: string = null) {
        this.fieldId = fieldId;
        this.venue = venue;
        this._mappedVenueId = mappedVenueId;
    }

    public get hasVenue(): boolean {
        return this.venue != null;
    }

    public get name(): string {
        if (this.venue != null) {
            return this.venue.name;
        }
        if (this.fieldId != null) {
            return `Plan ${this.fieldId}`;
        }
        return this._mappedVenueId || '';
    }

    public get venueId(): string {
        return this.venue != null ? this.venue.id : this._mappedVenueId;
    }

    public get venueKey(): string {
        if (this.venue != null) {
            return this.venue.id;
        }
        if (this._mappedVenueId != null) {
            return this._mappedVenueId;
        }
        if (this.fieldId != null) {
            return this.fieldId.toString();
        }
        throw new Error('VenueModel must have venue, mappedVenueId, or fieldId');
    }
}
